export default __webpack_public_path__ + "static/media/img-banner06.a8387c70.png";